import { useRovoWorkspace, useUnitsEnabled } from '@townsquare/collab-context';
import { useRouteDependencies } from '@townsquare/router/primitives/dependencies';
import { generatePath } from '@townsquare/router/primitives/path';
import { discoverRouteDefinition } from '@townsquare/routes/discover';
import { createSearchParamsFromCurrentUrl } from '@townsquare/search-params';

import { useIsDiscoverEnabled } from './use-is-discover-enabled';

/**
 * Hook that returns the full path for the Discover page

 * @returns The complete Discover path with optional cloudId query parameter
 */
export const useDiscoverPath = (): { discoverPath: string; isDiscoverEnabled: boolean } => {
	const routeDependencies = useRouteDependencies();
	const { discoverCloudId, isEnabled: isDiscoverEnabled } = useIsDiscoverEnabled();
	const basePath = generatePath(discoverRouteDefinition, routeDependencies);
	const cloudId = useRovoWorkspace();
	const unitsEnabled = useUnitsEnabled();

	const hasDiscoverInCurrentSite = discoverCloudId === cloudId;
	const hasDiscoverInUnit = !!discoverCloudId && discoverCloudId !== cloudId;

	// if the FF is off or the current site has discover enabled then return the path to the discover page
	if (!unitsEnabled || hasDiscoverInCurrentSite) {
		return { discoverPath: basePath, isDiscoverEnabled };
	}

	// if discover is enabled in the current unit then return the path to an arbitrarily chosen site in the unit with discover enabled
	if (hasDiscoverInUnit) {
		const queryParams = createSearchParamsFromCurrentUrl({ cloudId: discoverCloudId });
		return { discoverPath: `${basePath}?${queryParams.toString()}`, isDiscoverEnabled };
	}

	return { discoverPath: basePath, isDiscoverEnabled };
};
